<template>
  <nav class="vc-breadcrumbs" :aria-label="$t('ui_kit.breadcrumbs.aria_label')">
    <ol class="vc-breadcrumbs__list">
      <template v-for="(item, i) in items" :key="i">
        <template v-if="i < items.length - 1">
          <li class="vc-breadcrumbs__item">
            <!-- Innovadis custom: replace underscores and fircht char capitalized -->
            <component :is="item.route ? 'router-link' : 'span'" :to="item.route" class="vc-breadcrumbs__link">
              {{ item.title?.replace(/_/g, " ").replace(/^./, (char) => char.toUpperCase()) }}
            </component>
          </li>

          <!-- Innovadis custom: icon in stead of slash -->
          <li class="vc-breadcrumbs__item">
            <span class="vc-breadcrumbs__divider"><VcIcon name="breadcrumb-divider" size="xxs" /></span>
          </li>
        </template>

        <!-- Last breadcrumbs item -->
        <li v-else class="vc-breadcrumbs__item">
          <!-- Innovadis custom: replace underscores and fircht char capitalized -->
          {{ item.title?.replace(/_/g, " ").replace(/^./, (char) => char.toUpperCase()) }}
        </li>
      </template>
    </ol>
  </nav>
</template>

<script setup lang="ts">
interface IProps {
  items: IBreadcrumb[];
}

defineProps<IProps>();
</script>

<!-- Innovadis custom: styling -->
<style lang="scss">
.vc-breadcrumbs {
  &__list {
    @apply flex flex-wrap text-sm font-normal;
  }

  &__item {
    @apply text-[--color-body-text] items-center;
  }

  &__link {
    @apply text-[--color-body-text];

    &:hover {
      @apply text-[--link-hover-color];
    }
  }

  &__slash {
    @apply mx-2 text-neutral-300;
  }

  &__divider {
    @apply flex h-full mx-2 items-center text-[--color-body-text];
  }
}
</style>
